var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59771 15.8073C1.60943 16.1851 1.62119 16.564 1.62119 16.9429C5.53668 16.9429 9.45218 16.9429 13.3879 16.9362C12.5319 16.1406 11.7485 15.2249 11.7485 14.5028C11.7485 12.4782 14.2812 11.4657 15.5326 13.3243C15.5967 13.2292 15.6637 13.1417 15.7331 13.0615C15.2518 11.0915 13.608 9.79482 11.4008 9.78479H9.41372C11.4127 9.07855 12.502 7.58228 12.2746 5.8107C12.0471 4.07503 10.6706 2.74635 8.97083 2.62664C7.27108 2.50694 5.71496 3.59623 5.2601 5.2481C4.98479 6.2536 5.12843 7.21121 5.66708 8.08503C6.20574 8.97082 7.0197 9.48553 8.00125 9.76085C7.5691 9.78079 7.14433 9.78227 6.72079 9.78375C6.38179 9.78493 6.04357 9.78611 5.70299 9.79676C3.68005 9.85661 1.8965 11.3409 1.64513 13.3519C1.54651 14.1573 1.57203 14.9797 1.59771 15.8073Z",
    fill: "#AAABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.4845 13.5535C14.4509 12.0183 12.3589 12.8546 12.3589 14.5269C12.3589 15.7827 15.2269 17.747 15.4845 18.0024C15.7438 17.747 18.4692 15.7827 18.4692 14.5269C18.4692 12.8673 16.52 12.0183 15.4845 13.5535Z",
    fill: "#AAABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchRequests);
export default __webpack_public_path__ + "static/media/match_requests.f39cd50f7c4d0f107cdea63abb42bf16.svg";
export { ForwardRef as ReactComponent };